import { createContext, useContext, ReactNode, useEffect } from 'react';
import { useAuth as useFirebaseAuth } from '../hooks/useAuth';

type AuthContextType = {
  user: any;
  loading: boolean;
  error: any;
  login: (email: string, password: string) => Promise<void>;
  register: (name: string, email: string, password: string, extraData?: any) => Promise<{ id: string; email: string | null; username: string; }>;
  signOut: () => Promise<void>;
  resetPassword: (email: string) => Promise<void>;
} | null;

const AuthContext = createContext<AuthContextType>(null);

export function AuthProvider({ children }: { children: ReactNode }) {
  const auth = useFirebaseAuth();
  
  // Ajoutons un log pour déboguer
  useEffect(() => {
    console.log('Auth state changed:', auth.user);
  }, [auth.user]);

  return <AuthContext.Provider value={auth}>{children}</AuthContext.Provider>;
}

export function useAuth() {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error('useAuth must be used within AuthProvider');
  }
  return context;
}